export default __webpack_public_path__ + "static/media/info.12401831.svg";